import { useApp } from '../context/AppContext';
import React, { useState, useEffect, useCallback } from 'react';
const API = '/api/app';
const inputStyle = { background:'var(--input-bg)', border:'1px solid var(--border)', borderRadius:8, padding:'8px 12px', color:'var(--text-primary)', fontSize:13, width:'100%', boxSizing:'border-box' };

function PitchModal({ pitch, onClose, onSave, onDelete, token }) {
  const [form, setForm] = useState({
    name: pitch.name || '', city: pitch.city || '', address: pitch.address || '',
    location: pitch.location || '', price: pitch.price || 0, currency: pitch.currency || 'AED',
    isActive: pitch.isActive !== false,
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    const res = await fetch(`${API}/pitches/${pitch.id}`, {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    setSaving(false);
    if (res.ok) onSave({ ...pitch, ...form });
  };

  const del = async () => {
    if (!window.confirm(`Deactivate "${pitch.name}"?`)) return;
    const res = await fetch(`${API}/pitches/${pitch.id}`, {
      method: 'DELETE', headers: { Authorization: `Bearer ${token}` },
    });
    if (res.ok) onDelete(pitch.id);
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ background:'var(--card-bg)', borderRadius:16, padding:28, width:500, maxWidth:'95vw', border:'1px solid var(--border)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
          <span style={{ fontWeight:700, fontSize:16 }}>Edit Pitch</span>
          <button onClick={onClose} style={{ background:'none', border:'none', color:'var(--text-dim)', cursor:'pointer', fontSize:18 }}>✕</button>
        </div>
        {[['name','Name'],['city','City'],['address','Address'],['location','Location']].map(([k,l]) => (
          <div key={k} style={{ marginBottom:12 }}>
            <label style={{ fontSize:11, color:'var(--text-dim)', display:'block', marginBottom:4, textTransform:'uppercase' }}>{l}</label>
            <input style={inputStyle} value={form[k]} onChange={e => setForm(f => ({...f,[k]:e.target.value}))} />
          </div>
        ))}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 }}>
          <div>
            <label style={{ fontSize:11, color:'var(--text-dim)', display:'block', marginBottom:4, textTransform:'uppercase' }}>Price</label>
            <input type="number" style={inputStyle} value={form.price} onChange={e => setForm(f => ({...f,price:e.target.value}))} />
          </div>
          <div>
            <label style={{ fontSize:11, color:'var(--text-dim)', display:'block', marginBottom:4, textTransform:'uppercase' }}>Currency</label>
            <select style={inputStyle} value={form.currency} onChange={e => setForm(f => ({...f,currency:e.target.value}))}>
              {['AED','USD','GBP','EUR','NGN'].map(c => <option key={c}>{c}</option>)}
            </select>
          </div>
        </div>
        <div style={{ marginBottom:20 }}>
          <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13 }}>
            <input type="checkbox" checked={form.isActive} onChange={e => setForm(f => ({...f,isActive:e.target.checked}))} />
            Active (visible in marketplace)
          </label>
        </div>
        {pitch.metadata?.avgRating && (
          <div style={{ background:'rgba(167,244,50,0.05)', border:'1px solid rgba(167,244,50,0.15)', borderRadius:8, padding:'10px 14px', marginBottom:16, fontSize:12, color:'var(--text-dim)' }}>
            Playo Rating: ★ {pitch.metadata.avgRating} ({pitch.metadata.ratingCount} reviews) · {pitch.metadata.timings || 'Timings N/A'}
          </div>
        )}
        <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
          <button onClick={del} style={{ background:'rgba(255,50,50,0.1)', color:'#ff4444', border:'1px solid rgba(255,50,50,0.3)', borderRadius:8, padding:'8px 16px', cursor:'pointer', fontSize:13, fontWeight:600 }}>Deactivate</button>
          <button onClick={save} disabled={saving} style={{ background:'#a7f432', color:'#0f1a10', border:'none', borderRadius:8, padding:'8px 20px', cursor:'pointer', fontSize:13, fontWeight:700 }}>
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Pitches() {
  const { token } = useApp();
  const [pitches, setPitches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [city, setCity] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selected, setSelected] = useState(null);
  const [cities, setCities] = useState([]);
  const limit = 50;

  const load = useCallback(async (p = 1) => {
    setLoading(true);
    const qs = new URLSearchParams({ limit, page: p, ...(search && { search }), ...(city && { city }) });
    const res = await fetch(`${API}/all-pitches?${qs}`, { headers: { Authorization: `Bearer ${token}` } });
    const d = await res.json();
    setPitches(d.data || []);
    setTotal(d.total || 0);
    setLoading(false);
  }, [search, city]);

  useEffect(() => { load(1); setPage(1); }, [search, city]);

  useEffect(() => {
    fetch(`${API}/all-pitches?limit=500`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => {
        const uniqueCities = [...new Set((d.data || []).map(p => p.city).filter(Boolean))].sort();
        setCities(uniqueCities);
      });
  }, []);

  const onSave = (updated) => {
    setPitches(prev => prev.map(p => p.id === updated.id ? updated : p));
    setSelected(null);
  };

  const onDelete = (id) => {
    setPitches(prev => prev.map(p => p.id === id ? { ...p, isActive: false } : p));
    setSelected(null);
  };

  const totalPages = Math.ceil(total / limit);

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div>
          <h2 style={{ margin:0, fontSize:22, fontWeight:700 }}>Pitch Marketplace</h2>
          <p style={{ margin:'4px 0 0', color:'var(--text-dim)', fontSize:13 }}>{total} pitches across UAE</p>
        </div>
      </div>

      <div style={{ display:'flex', gap:12, marginBottom:20 }}>
        <input style={{ ...inputStyle, maxWidth:320 }} placeholder="Search by name, city, location..." value={search} onChange={e => setSearch(e.target.value)} />
        <select style={{ ...inputStyle, maxWidth:180 }} value={city} onChange={e => setCity(e.target.value)}>
          <option value="">All Cities</option>
          {cities.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:60, color:'var(--text-dim)' }}>Loading pitches...</div>
      ) : (
        <>
          <div style={{ background:'var(--card-bg)', borderRadius:12, border:'1px solid var(--border)', overflow:'hidden' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
              <thead>
                <tr style={{ background:'rgba(255,255,255,0.03)', borderBottom:'1px solid var(--border)' }}>
                  {['Pitch Name','City','Address','Price','Rating','Status','Actions'].map(h => (
                    <th key={h} style={{ padding:'12px 14px', textAlign:'left', fontWeight:600, fontSize:11, textTransform:'uppercase', color:'var(--text-dim)', letterSpacing:'0.05em' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pitches.map((p, i) => (
                  <tr key={p.id} style={{ borderBottom:'1px solid rgba(255,255,255,0.04)', background: i%2===0 ? 'transparent' : 'rgba(255,255,255,0.01)' }}>
                    <td style={{ padding:'11px 14px', fontWeight:600, color:'var(--text-primary)', maxWidth:200 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        {p.images?.[0] && <img src={p.images[0]} alt="" style={{ width:32, height:32, borderRadius:6, objectFit:'cover', flexShrink:0 }} onError={e => e.target.style.display='none'} />}
                        <span style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.name}</span>
                      </div>
                    </td>
                    <td style={{ padding:'11px 14px', color:'var(--text-dim)' }}>{p.city || '—'}</td>
                    <td style={{ padding:'11px 14px', color:'var(--text-dim)', maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.address || '—'}</td>
                    <td style={{ padding:'11px 14px', color:'var(--text-primary)' }}>{p.price > 0 ? `${p.currency} ${p.price}` : <span style={{ color:'var(--text-dim)' }}>TBD</span>}</td>
                    <td style={{ padding:'11px 14px', color:'#F5A623' }}>{p.metadata?.avgRating ? `★ ${p.metadata.avgRating}` : '—'}</td>
                    <td style={{ padding:'11px 14px' }}>
                      <span style={{ background: p.isActive ? 'rgba(167,244,50,0.12)' : 'rgba(255,80,80,0.12)', color: p.isActive ? '#A7F432' : '#ff6b6b', borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:600 }}>
                        {p.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td style={{ padding:'11px 14px' }}>
                      <button onClick={() => setSelected(p)} style={{ background:'rgba(167,244,50,0.1)', color:'#a7f432', border:'1px solid rgba(167,244,50,0.2)', borderRadius:6, padding:'4px 12px', cursor:'pointer', fontSize:12, fontWeight:600 }}>Edit</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:16 }}>
            <span style={{ color:'var(--text-dim)', fontSize:13 }}>Showing {(page-1)*limit+1}–{Math.min(page*limit,total)} of {total}</span>
            <div style={{ display:'flex', gap:8 }}>
              <button onClick={() => { setPage(p => p-1); load(page-1); }} disabled={page<=1} style={{ background:'var(--card-bg)', border:'1px solid var(--border)', color:'var(--text-primary)', borderRadius:8, padding:'6px 14px', cursor:'pointer', fontSize:13 }}>← Prev</button>
              <button onClick={() => { setPage(p => p+1); load(page+1); }} disabled={page>=totalPages} style={{ background:'var(--card-bg)', border:'1px solid var(--border)', color:'var(--text-primary)', borderRadius:8, padding:'6px 14px', cursor:'pointer', fontSize:13 }}>Next →</button>
            </div>
          </div>
        </>
      )}

      {selected && <PitchModal pitch={selected} onClose={() => setSelected(null)} onSave={onSave} onDelete={onDelete} token={token} />}
    </div>
  );
}
